import { useState } from 'react';

import { useGetNayaxMdbTemplatesQuery, useDeleteNayaxMdbTemplateMutation } from 'data/__generated__';

import { DataTable } from 'components/DataTable';
import { Loader } from 'components/Loader';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';

import { nayaxMDBTemplatesColumns, type NayaxMDBTemplateRow } from '../constants/nayaxMDBTemplatesColumns';

export const NayaxMDBTemplatesList = () => {
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);
    const {
        loading: templatesLoading,
        data: templatesData,
        error: templatesError,
        refetch,
    } = useGetNayaxMdbTemplatesQuery();
    const [deleteNayaxMdbTemplateMutation] = useDeleteNayaxMdbTemplateMutation();

    const handleDeleteSelected = async () => {
        for (const templateId of selectedKeys) {
            await deleteNayaxMdbTemplateMutation({
                variables: {
                    nayaxMDBTemplateId: templateId,
                },
            });
        }
        setSelectedKeys([]);
        refetch();
    };

    if (templatesLoading) {
        return (
            <div className="flex h-full w-full items-center justify-center">
                <Loader />
            </div>
        );
    }

    if (!templatesData || templatesError) {
        throw new Error('Une erreur est survenue lors de la récupération des templates');
    }

    const { nayaxMDBTemplates } = templatesData;

    return (
        <div className="flex h-full w-full flex-col overflow-hidden">
            <DataTable<NayaxMDBTemplateRow>
                columns={nayaxMDBTemplatesColumns}
                data={nayaxMDBTemplates}
                filterMode="client"
                getRowId={(row) => row._id}
                getRowLink={(row) => `/nayax-mdb-template/${row._id}`}
                searchPlaceholder="Nom du template"
                searchFilterKey="searchValue"
                enableSelection
                selectedKeys={selectedKeys}
                onSelectionChange={setSelectedKeys}
                toolbarActions={
                    selectedKeys.length > 0 ? (
                        <TotemPrimaryButton onClick={handleDeleteSelected}>
                            Supprimer les templates sélectionnés
                        </TotemPrimaryButton>
                    ) : null
                }
            />
        </div>
    );
};
